var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './TextEditor.scss';
import classNames from 'classnames';
import { useCurrentUser } from '@hooks';
import { Editor } from '@ui/Editor';
import React, { forwardRef } from 'react';
export const TextEditor = forwardRef((_a, ref) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const { isReadOnly } = useCurrentUser();
    const { isReadOnly: propsIsReadOnly } = rest;
    return (React.createElement(Editor, Object.assign({}, rest, { className: classNames('periscope-text-editor', className), editOnClick: true, isReadOnly: propsIsReadOnly || isReadOnly, ref: ref, saveOnBlur: true })));
});
